import { ChipInfoStatusEnum } from "components/Status/ChipInfo/chipInfo.interface"

export enum StatusLearningResultEnum {
  NotStarted = 0,
  Passed = 1,
  NotPassed = 2,
  HasPassedIn30Days = 3
}

export const learningStatusEnum = (type: StatusLearningResultEnum): ChipInfoStatusEnum => {
  switch (type) {
    case StatusLearningResultEnum.NotStarted:
      return ChipInfoStatusEnum.NotStarted
    case StatusLearningResultEnum.Passed:
      return ChipInfoStatusEnum.Passed
    case StatusLearningResultEnum.NotPassed:
      return ChipInfoStatusEnum.NotPassed
    default:
      return ChipInfoStatusEnum.New
  }
}
